// Smaller image variant for cards/thumbnails: our uploads (?w=), Unsplash/Pexels (w=).
export const thumb = (url, w = 400) => {
  if (!url || typeof url !== 'string') return url;
  url = url.replace(/^https?:\/\/[^/]+(?=\/api\/uploads\/)/, '');
  if (url.includes('/api/uploads/')) return url.includes('?') ? url : `${url}?w=${w}`;
  if (/images\.(unsplash|pexels)\.com/.test(url)) return /[?&]w=\d+/.test(url) ? url.replace(/([?&])w=\d+/, `$1w=${w}`) : `${url}${url.includes('?') ? '&' : '?'}w=${w}`;
  return url;
};
